export default __webpack_public_path__ + "static/media/Japsbag.28b6024c.jpg";